<template>
  <div class="form-group theme-payment-page-form-item">
    <i class="fa fa-angle-down"></i>
    <select
      :id="`input-field-${_uid}`"
      :name="name"
      v-model="modelField"
      v-validate="required ? validate : ''"
      @change="$emit('update:field', $event.target.value)"
      :class="{ 'alert-danger': submitted && errors.has(name) }"
      class="form-control">
      <option value="">Ano</option>
      <option
        v-for="(year, index) in years"
        :key="`select-year-${index}`"
        :value="year">{{ year }}</option>
    </select>
    <span class="theme-form-error-message">{{ errors.first(name) }}</span>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  inject: [ '$validator' ],
  props: [
    'name',
    'submitted',
    'required',
    'validate',
    'field',
    'label'
  ],
  data () {
    return {
      modelField: '',
      modelValidate: ''
    }
  },
  computed: {
    years () {
      const years = []
      const dateStart = moment()
      const dateEnd = moment().add(20, 'y')

      while (dateEnd.diff(dateStart, 'years') >= 0) {
        years.push(dateStart.format('YYYY'))
        dateStart.add(1, 'year')
      }
      return years
    }
  },
  watch: {
    field (data) {
      this.modelField = data
    }
  }
}
</script>
